import { useMemo, useRef } from "react";
import { appId } from "../config";
import useUser from "./useUser";
import useIsTeam from "./useIsTeam";
import { useRouter } from "next/router";
import { Realtime, Types } from "ably";
import { API_URL } from "../backend";

const activeConnections = new Map();

const useAbly = (): Types.RealtimePromise => {
  const router = useRouter();
  const { user } = useUser({
    haltRequest:
      router.pathname.startsWith("/login") ||
      router.pathname.startsWith("/register"),
  });
  const { id, isTeam } = useIsTeam();

  const prevClientIdRef: any = useRef();

  return useMemo(() => {
    const clientId = isTeam ? id : user?.id || appId;

    if (prevClientIdRef.current !== clientId) {
      const prevSocket = activeConnections.get(prevClientIdRef.current);
      if (prevSocket) {
        prevSocket?.close();
        activeConnections.delete(prevClientIdRef.current);
      }
      prevClientIdRef.current = clientId;
    }

    const existingSocket = activeConnections.get(clientId);
    if (existingSocket) return existingSocket;

    const ably = new Realtime.Promise({
      authUrl: `${API_URL}/v1/ably/token?clientId=${clientId}`,
      clientId,
    });

    ably.connection.once("connected").then(() => {
      console.log("Ably Connected");
    });

    activeConnections.set(clientId, ably);

    return ably;
  }, [id, isTeam, user?.id]);
};

export default useAbly;
